// HOOKS
import useReturnTableComponents from "../../../hooks/other/useReturnTableComponents";

const DEFAULT_CLASSNAMES = {
  tr: "bg-slate-100",
  checkbox: "checked:accent-primary h-full mx-4 my-5 items-center",
};

const TableRow = ({
  fields,
  select,
  checked,
  handleSelect = () => {},
  data,
  classNames = DEFAULT_CLASSNAMES,
}) => {
  const { getTableComponents } = useReturnTableComponents();
  return (
    <tr className={classNames?.tr || DEFAULT_CLASSNAMES.tr}>
      {select && (
        <td>
          <input
            data-_id={data?._id}
            type="checkbox"
            name="table-row-checkbox"
            checked={checked}
            className={classNames?.checkbox || DEFAULT_CLASSNAMES.checkbox}
            onChange={handleSelect}
          />
        </td>
      )}
      {getTableComponents({
        fields: fields,
      })}
    </tr>
  );
};

export default TableRow;
